import React from 'react'
import Ellipse from '../../images/integration-pages/ellipse'

const DocsListItem = ({text}) => {
    return (
        <>
            <div className="relative w-11/12 px-2 inline-flex space-x-5 text-left">
                <div className="w-1/12 absolute -top-0.5 xs:-top-1  md:top-0.5 lg:top-1 left-2">
                    <Ellipse />
                </div>
                <span className="w-11/12 text-sm md:text-base lg:text-lg leading-6 md:leading-7 lg:leading-9 break-words">{text}</span>
            </div>
        </>
    )
}

export default DocsListItem
